import { Component, OnInit } from '@angular/core';
import { GridBaseComponent } from '../../../base/shared/grid-base/grid-base.component';
import { ClientService } from '../../../base/services/client/client.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TagsAdministrationService } from './tags-administration.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../../base/spinner/spinner.service';
import { ClientDTO, ControlPlateType, ParkerTagDTO } from '../../../base/models/models.swagger.generated';
import { GridConstantsFactory } from '../../../base/shared/syncfusion/grid-constants-factory';
import { CommandModel, SaveEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { Router } from '@angular/router';
import { parkerAdministrationRoute } from '../../../core/routing/route-names';
import { FormBuilder } from '@angular/forms';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { DatePipe } from '@angular/common';
import { ClientAutocompleteComponent } from '../../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-tags-administration',
    templateUrl: './tags-administration.component.html',
    styleUrls: ['./tags-administration.component.scss'],
    imports: [
        TitleBarComponent,
        ClientAutocompleteComponent,
        SearchFieldComponent,
        CheckBoxModule,
        GridModule,
        TranslateModule,
        DatePipe
    ]
})
export class TagsAdministrationComponent extends GridBaseComponent implements OnInit {

  public checkBoxFilter = GridConstantsFactory.createCheckBoxFilter();
  public isDefectFilter = GridConstantsFactory.createCheckBoxFilter();
  public enableAutomaticPlateRecognitionParkingFilter = GridConstantsFactory.createCheckBoxFilter();

  constructor(clientService: ClientService,
              translate: TranslateService,
              private tagsAdministrationService: TagsAdministrationService,
              private router: Router,
              private fb: FormBuilder,
              private spinnerService: SpinnerService) {
    super(clientService, translate, tagsAdministrationService);
    this.searchOptions = {fields: ['barcode', 'countryCode', 'identificationCode', 'description']};
    this.gridCommands = [
      {
        type: SfCommandButtonType.Edit,
        buttonOption: {
          cssClass: 'icon-btn',
          iconCss: 'icon-edit e-icons',
        },
      } as CommandModel,
    ];
    this.additionalShowInactiveColumns = ['defect'];
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.tagsAdministrationService, this.spinnerService),
    });
    this.isActiveColumnName = 'active';
    this.editDialogTitle = 'i18n.domain.tags-administration.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.tags-administration.add-dialog-title';
    this.addIndexFindColumnName = 'id';
  }

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public override set selectedClient(value: ClientDTO) {
    this.clientService.selectedClient = value;
    this.onClientSelected(value);
  }

  public override actionBegin(args: SaveEventArgs) {
    if (args.requestType === 'beginEdit') {
      const parkerId = (args.rowData as ParkerTagDTO).parkerId;
      this.router.navigate([parkerAdministrationRoute], {queryParams: {parkerId}});
      args.cancel = true;
    }
  }

  public formatControlPlateType(data): string {
    return 'i18n.shared.controlPlateType.' + ControlPlateType[data.controlPlateType];
  }

  protected getEditDialogTitleParams(rowData: any): any {
    return null;
  }

  protected initializeEditForm(data: any): void {
    this.gridEditForm = this.fb.group({});
  }

}
